// extracted by mini-css-extract-plugin
export default {"RainbowButton":"JoinButton_RainbowButton__2+yDN","InputButton":"JoinButton_InputButton__xfOIz","slidebg":"JoinButton_slidebg__O+Xuq"};